import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import LinkCard from "../../../LinkCard";
import MailroomSchool from "../../../mailroom/MailroomSchool";
import { MailroomSchoolConfig } from "../../../../models/MailroomSchoolConfig";
import AdminSchoolMenu from "../../../AdminSchoolMenu";
import { CommandBarButton, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { CDBMain } from "../../../CDBMain";
import ReactDOM from "react-dom";
import Actions from "../../../../redux/Actions";
import SchoolPageTitle from "../../../SchoolPageTitle";

interface MailroomSchoolPageProps {
    tenantId: string;
    schoolCode: string;

    history: H.History;
    apiService: ApiService;
}

interface MailroomSchoolPageState {
    mailroomSchoolConfig?: MailroomSchoolConfig | null;
    addInProgress: boolean;
}

class MailroomSchoolPage extends Component<MailroomSchoolPageProps & DispatchProps, MailroomSchoolPageState> {

    constructor(props: MailroomSchoolPageProps & DispatchProps) {
        super(props);

        this.state = {
            mailroomSchoolConfig: undefined,
            addInProgress: false
        };
    }

    async componentDidUpdate(prevProps: Readonly<MailroomSchoolPageProps & DispatchProps>, prevState: Readonly<MailroomSchoolPageState>, snapshot?: any): Promise<void> {

    }

    async componentDidMount() {
        const mailroomSchoolConfig = await this.props.apiService.getMailroomSchoolConfig(this.props.tenantId, this.props.schoolCode);
        this.setState({
            mailroomSchoolConfig
        });
    }


    private renderNoConfigMessageBar(): JSX.Element | null {
        if (this.state.mailroomSchoolConfig !== null) {
            return null;
        }

        const parent = document.querySelector(`.${CDBMain.contentHeaderClass}`);
        const messageBar = (
            <MessageBar messageBarType={MessageBarType.warning}>
                <span>This school has not been added to mailroom, it can be added below to enable all features.</span>
            </MessageBar>
        )

        return ReactDOM.createPortal(messageBar, parent!);
    }

    private renderAddToMailroom = (): JSX.Element | undefined => {
        if (this.state.mailroomSchoolConfig !== null) {
            return undefined;
        }

        return (
            <CommandBarButton
                iconProps={{ iconName: "NewMail" }}
                disabled={this.state.addInProgress}
                onClick={async () => {
                    if (this.state.mailroomSchoolConfig !== null) {
                        return null;
                    }

                    this.setState({
                        addInProgress: true
                    });

                    try {
                        await this.props.apiService.saveSchoolMailroomConfig(this.props.tenantId!, this.props.schoolCode!, {
                            mailroomSchoolConfig: {},
                            subjectMerges: undefined
                        } as any);

                        this.props.dispatch(Actions.showMessageBar(`Successfully added school to mailroom`, MessageBarType.success));

                        this.props.history.push(`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/config`);

                    } catch (e) {
                        console.log(e);
                        this.props.dispatch(Actions.showMessageBar(`Error adding school to mailroom : ${e}`, MessageBarType.error));
                    }

                    this.setState({
                        addInProgress: false
                    });

                }}
                text="Add to Mailroom"
            />
        );

    }

    render() {

        const automationUrl = this.state.mailroomSchoolConfig?.sdsProfileId ? `/cdb-admin/mailroom/${this.props.tenantId}/automation/${this.state.mailroomSchoolConfig.sdsProfileId!}` : null;

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Mailroom" /> 

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <MailroomSchool schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} enableLinkToSchool={false}>
                    {this.renderAddToMailroom()}
                </MailroomSchool>

                {this.renderNoConfigMessageBar()}

                <div className={"flex-row"}>

                    <LinkCard title={"MIS Data (Inbox)"}
                        to={`/cdb-admin/mis-data/${this.props.tenantId}/${this.props.schoolCode}`}
                        iconName={"Database"} description={"Browse and configure incoming school data"} />

                    <LinkCard title={"Configure"}
                        disabled={this.state.mailroomSchoolConfig === null}
                        to={`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/config`}
                        iconName={"Settings"} description={"Configure schools mailroom settings"} />

                    <LinkCard title={"Automation"}
                        disabled={automationUrl === null}
                        to={automationUrl || ""}
                        iconName={"Robot"}
                        description={"See and configure automatic processing and uploads"} />
                </div>

                <div className={"flex-row"}>
                    <LinkCard title={"Processor Viewer"}
                        disabled={this.state.mailroomSchoolConfig === null}
                        to={`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/process`}
                        iconName={"Running"} description={"View processor instances"} />
                    <LinkCard title={"SDS Viewer"}
                        to={`/cdb-admin/mailroom/${this.props.tenantId}/sds/industrydata`}
                        iconName={"CloudUpload"}
                        description={"View the SDS flows for this tenant"} />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): MailroomSchoolPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            history: ownProps.history,
            apiService: state.auth.apiService
        };
    }
)(MailroomSchoolPage);